import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake } from "caseparser";

export const lessonsApi = api
  .enhanceEndpoints({ addTagTypes: ["rooms"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      rooms: builder.query({
        query: ({ branchId }: any) => ({
          url: `branchs/${branchId}/rooms`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response.data,
        providesTags: ["rooms"],
      }),
      createRoom: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/rooms`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["rooms"],
      }),
      updateRoom: builder.mutation({
        query: ({ branchId, id, name, color, description }: any) => ({
          url: `branchs/${branchId}/rooms/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["rooms"],
      }),
      deleteRoom: builder.mutation({
        query: ({ branchId, id }: any) => ({
          url: `branchs/${branchId}/rooms/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["rooms"],
      }),
    }),
  });

export const {
  useRoomsQuery,
  useCreateRoomMutation,
  useUpdateRoomMutation,
  useDeleteRoomMutation,
} = lessonsApi;
